module.exports = __webpack_public_path__ + "188774365efa9fc13155cbbbca0c6700.ico"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/customization/favicon/hkspop.ico
 ** module id = 1344
 ** module chunks = 0
 **/